import { AnyAction } from "redux";

import { myFleetActions } from "../reducer/reducer";
import { SortTypeMyFleet } from "features/myFleet/types";

export const setSortOrder = (order: SortTypeMyFleet): AnyAction =>
  myFleetActions.setSortOrder(order);
